import { useQuery } from "@tanstack/react-query";
import { App, Button, Col, Flex, Result, Row } from "antd";
import { attributeDataOption } from "$attribute/queries";
import ErrorPage from "$components/ErrorPage";
import Attribute from "$components/Attribute";
import { Labels } from "$components/AttributeLabels";
import Loading from "$components/Loading";
import { usePutAttribute } from "../queries";
import { useState } from "react";

const AttributeView = () => {
  const {
    data: attributes,
    isPending,
    isError,
    error,
  } = useQuery(attributeDataOption);
  const { notification } = App.useApp();
  const [toUpdateAttributes, setToUpdateAttributes] = useState(null);
  const updateAttribute = usePutAttribute();

  if (isPending) {
    return <Loading />;
  }

  if (isError) {
    console.error(error);
    return (
      <ErrorPage
        text={"Entschuldigen Sie! Etwas ist schief gelaufen!"}
        navigatePath={"/home"}
        buttonText={"Zurück zum Start"}
      />
    );
  }
  if (!attributes || attributes.length === 0) {
    return (
      <Result
        status="404"
        title="Keine Merkmale"
        subTitle="Entschuldigen Sie, es sind keine Merkmale zum Anzeigen verfügbar."
      />
    );
  }

  return (
    <>
      <Flex justify="center">
        <Row gutter={[16, 16]} wrap={false}>
          <Labels />
          <div key={attributes} className="scrollable-container">
            {attributes.map((attribute) => (
              <Col key={attribute.id} flex="200px">
                <Attribute
                  object={attribute}
                  showUidRadio={true}
                  onChange={(change) => {
                    const { uuid, ...change_no_id_and_uuid } = change;
                    console.log(attribute.id);
                    console.log(toUpdateAttributes);
                    if (!!toUpdateAttributes && toUpdateAttributes !== null) {
                      if (attribute.id in toUpdateAttributes) {
                        setToUpdateAttributes({
                          ...toUpdateAttributes,
                          [attribute.id]: {
                            ...toUpdateAttributes[attribute.id],
                            ...change_no_id_and_uuid,
                          },
                        });
                      } else {
                        setToUpdateAttributes({
                          ...toUpdateAttributes,
                          [attribute.id]: {
                            ...change_no_id_and_uuid,
                          },
                        });
                      }
                    } else {
                      setToUpdateAttributes({
                        ...toUpdateAttributes,
                        [attribute.id]: {
                          ...change_no_id_and_uuid,
                        },
                      });
                    }
                  }}
                />
              </Col>
            ))}
          </div>
        </Row>
      </Flex>
      <Flex justify="end">
        <Button
          type="primary"
          disabled={toUpdateAttributes === null}
          onClick={() => {
            let attributes = Object.entries(toUpdateAttributes).map(
              ([key, value]) => ({
                id: Number(key),
                ...value,
              })
            );
            updateAttribute.mutate(
              {
                attributes,
              },
              {
                onSuccess: (response) => {
                  notification.success({ message: response[0].success });
                },
                onError: (response) => {
                  notification.success({ message: response[0].error });
                },
              }
            );
            setToUpdateAttributes(null);
          }}
        >
          Update Attributes
        </Button>
      </Flex>
    </>
  );
};

export default AttributeView;
